import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { COMMON_PROPERTY } from '../../store/property/common/commonProperty.reducer';
import { Button, Col, Form, Modal } from 'react-bootstrap';
import { ValidationForm, TextInput, Checkbox } from 'react-bootstrap4-form-validation';
import { useDispatch } from 'react-redux';
import { PROPERTY_MASTER } from '../../store/propertyMaster/propertyMaster.reducer';
import { PROPERTY_MODAL_CLOSE } from '../../store/actions';
import { createCommonProperty, createCommonPropertyUserForm } from '../../store/property/common/commonProperty.actions';
import { COMMON_PROPERTY_USERFORM_RESET } from '../../store/property/common/commonProperty.actionsType';
// let maxSno;
const CommonPropertyModal = ({ apiCall, apiCallId, itemList, id }) => {
    let [siNo, setSiNo] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    let [maxSno, setMaxSno] = useState();
    let { isPropertyFormModal, buttonStatus, propertyComponentId } = useSelector((state) => {
        return state.able;
    });
    let { commonPropertyUserform } = useSelector((state) => {
        return state[COMMON_PROPERTY];
    });
    let { ipAddressInfo } = useSelector((state) => {
        return state[PROPERTY_MASTER];
    });
    let dispatch = useDispatch();
    const reset = useRef();

    useEffect(() => {
        if (itemList && itemList.length > 0) {
            let x = itemList.map((item) => {
                return item.fldSlNo;
            });
            let maxNo = Math.max(...x);
            setMaxSno(maxNo + 1);
            let key = 'slno';
            let value = maxNo + 1;
            dispatch(createCommonPropertyUserForm(key, value));
        } else {
            setMaxSno(1);
        }
    }, [dispatch, itemList]);

    useEffect(() => {
        itemList?.length == 0 && dispatch(createCommonPropertyUserForm('slno', 1));
    }, [dispatch, itemList?.length]);

    useEffect(() => {
        if (propertyComponentId === id) {
            setOpenModal(isPropertyFormModal);
        }
    }, [isPropertyFormModal]);

    useEffect(() => {
        if (propertyComponentId === id) {
            setOpenModal(isPropertyFormModal);
        }
    }, []);

    let handleCommonPropertyChange = (event) => {
        let key = event.target.name;
        let value = event.target.value;
        if (key === 'check') value = event.target.checked;
        dispatch(createCommonPropertyUserForm(key, value));
    };

    const handleCommonPropertySubmit = async (e, formData, inputs) => {
        e.preventDefault();
        let resetRef = reset.current;
        let button = e?.nativeEvent?.submitter?.name;
        if (button === 'Create') {
            formData['ipv4'] = ipAddressInfo?.IPv4 ?? null;
            formData['propertySelect'] = apiCallId;
            await dispatch(createCommonProperty(formData, true, apiCall, id));
            resetRef.resetValidationState(true);
        }
        if (button === 'addNew') {
            formData['ipv4'] = ipAddressInfo?.IPv4 ?? null;
            formData['propertySelect'] = apiCallId;
            await dispatch(createCommonProperty(formData, false, apiCall, id));
            resetRef.resetValidationState(true);
        }
    };

    const handleErrorSubmit = (e, formData, errorInputs) => {
        //console.log(errorInputs);
    };

    return (
        <Modal
            scrollable={true}
            centered
            show={openModal}
            onHide={() => {
                dispatch({ type: PROPERTY_MODAL_CLOSE, id: id });
                dispatch({ type: COMMON_PROPERTY_USERFORM_RESET });
            }}
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5">Create Property</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ValidationForm ref={reset} onSubmit={handleCommonPropertySubmit} onErrorSubmit={handleErrorSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} md="6">
                            <Form.Label htmlFor="slno">SL No.</Form.Label>
                            <TextInput
                                name="slno"
                                id="slno"
                                placeholder="SL No."
                                pattern="^[0-9]+$"
                                errorMessage={{
                                    pattern: 'Only positive numbers are allowed'
                                }}
                                required
                                disabled={buttonStatus === 'delete' && true}
                                defaultValue={maxSno}
                                value={commonPropertyUserform.slno}
                                onChange={handleCommonPropertyChange}
                                autoComplete="off"
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6">
                            <Form.Label htmlFor="description">Description</Form.Label>
                            <TextInput
                                name="description"
                                id="description"
                                placeholder="Description"
                                pattern="^[ A-Za-z0-9()%*.,+/-]+$"
                                errorMessage={{
                                    pattern: 'Limited special characters are allowed'
                                }}
                                maxLength={apiCallId === 4 && 6}
                                minLength={apiCallId === 4 && 6}
                                disabled={buttonStatus === 'delete' && true}
                                required
                                value={commonPropertyUserform.description}
                                onChange={handleCommonPropertyChange}
                                autoComplete="off"
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6">
                            <Form.Label htmlFor="sdescription">Short Description</Form.Label>
                            <TextInput
                                name="sdescription"
                                id="sdescription"
                                placeholder="Short Description"
                                pattern="^[ A-Za-z0-9()%*.,+/-]+$"
                                errorMessage={{
                                    pattern: 'Limited special characters are allowed'
                                }}
                                maxLength={apiCallId === 4 && 6}
                                minLength={apiCallId === 4 && 6}
                                disabled={buttonStatus === 'delete' && true}
                                required
                                value={commonPropertyUserform.sdescription}
                                onChange={handleCommonPropertyChange}
                                autoComplete="off"
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="12">
                            <Checkbox
                                name="check"
                                label="Set as Default"
                                id="check"
                                value={commonPropertyUserform.check}
                                inline
                                onChange={handleCommonPropertyChange}
                            />
                        </Form.Group>
                        <Form.Group as={Col} sm={12} className="d-flex justify-content-around">
                            <Button
                                onClick={() => {
                                    dispatch({ type: PROPERTY_MODAL_CLOSE, id: id });
                                    dispatch({ type: COMMON_PROPERTY_USERFORM_RESET });
                                }}
                                variant="secondary"
                                size="sm"
                            >
                                Close
                            </Button>
                            {buttonStatus === 'create' && (
                                <>
                                    <Button type="submit" variant="primary" name="addNew" value="addNew" size="sm">
                                        Save & Add New
                                    </Button>
                                    <Button variant="info" type="submit" name="Create" value="Create" size="sm">
                                        Save & Close
                                    </Button>
                                </>
                            )}
                        </Form.Group>
                    </Form.Row>
                </ValidationForm>
            </Modal.Body>
        </Modal>
    );
};

export default CommonPropertyModal;
